<template>
    <div class="w1200">

        <div v-if="vuex_downFile_progress" style="
				position: fixed;
				bottom: 0px;
				background: #1296DB;
				right: 0;
				left: 0;
				padding: 20px;
				box-sizing: border-box;
				z-index: 10;
				text-align: center;
				font-weight: bold;
				color: #fff;
				font-size: 26px;
			
			">
            文件下载中，请稍等...
            <el-progress :text-inside="true" :stroke-width="26" :percentage="vuex_downFile_progress" status="success"></el-progress>
        </div>

        <div class="lottery">
            <span v-for="(item, index) in lottery.arr" :key="index" :class="lottery.active == index ? 'active' : ''" @click="lotteryToggle(index)">{{ item }}</span>
        </div>

        <div class="type">
            <div> <span v-for="(item, index) in type.arr" :key="index">{{ item }}</span> </div>

			<div>
                <span class="apply_sss" style=" background-color: #347CAF; color: #fff; margin-right: 30px; " @click="$router.push('/ssdgw')" >寻找单项名列前茅</span>
                <span class="apply_sss" @click="$router.push('/personalCenter/hangjiaguanli/apply_sss')" >申请缩水师</span>
            </div>

            <div class="flexrow">
                <el-input class="searchinput" v-model="searchKey" placeholder="请输入搜素内容"></el-input>
                <el-button @click="getList" type="primary">搜索</el-button>
            </div>
            
        </div>
        <div class="table">
            <div class="head">
                <div class="tit">{{ lotteryText }} {{ currentNumber || '--' }}期缩水师预测汇总</div>

                <div class="nav">
                    <span v-for="(item, index) in typeVIP.arr" :key="index" @click="typeVIP.active = index" :class="typeVIP.active === index ? 'active' : ''">{{ item }}</span>
                </div>

                <div class="nav">
                    <span v-for="(item, index) in headNav.arr" :key="index" @click="toggleNumber(index)" :class="headNav.active === index ? 'active' : ''">{{ item }}</span>
                </div>

                <!-- <div v-if="lottery.active == 0" style="display: flex; ">双色球开奖号码：
					<div style="display: flex; flex-direction: column; align-items: flex-start;">
						<span>{{winning_number}}</span>
						<span>(每周二，四，日 21：16)</span>
					</div>
				</div> -->

                <!-- <div v-if="lottery.active == 0">双色球开奖号码：{{winning_number}} (每周二，四，日 21：16)</div>
                <div v-if="lottery.active == 1">大乐透开奖号码：{{winning_number}}(每周一，三，六 21：25)</div>
                <div v-if="lottery.active == 2">福彩3D开奖号码：{{winning_number}}(每日 21：15（3d试机号18:30）)</div>
                <div v-if="lottery.active == 3">排列三开奖号码：{{winning_number}}(每日 21：25)</div> -->

                <div v-if="lottery.active == 0">双色球开奖号码：{{handleLottery(winning_number,'ssq') || '(每周二，四，日 21：16)'}}</div>
                <div v-if="lottery.active == 1">大乐透开奖号码：{{handleLottery(winning_number,'dlt') || '(每周一，三，六 21：25)'}}</div>
                <div v-if="lottery.active == 2">福彩3D开奖号码：{{winning_number || '(每日 21：15（3d试机号18:30）)'}}</div>
                <div v-if="lottery.active == 3">排列三开奖号码：{{winning_number || '(每日 21：25)'}}</div>

            </div>
            <ssqTable ref="ssqTable" @downloadFile="downloadFile" @view_download="view_download" :tableData="tableData" v-if="lottery.active == 0" />
            <dltTable ref="dltTable" @downloadFile="downloadFile" @view_download="view_download" :tableData="tableData" v-if="lottery.active == 1" />
            <fcsdTable ref="fcsdTable" @downloadFile="downloadFile" @view_download="view_download" :tableData="tableData" v-if="lottery.active == 2" />
            <plsTable ref="plsTable" @downloadFile="downloadFile" @view_download="view_download" :tableData="tableData" v-if="lottery.active == 3" />

            <el-pagination v-if="listPagin.total > 9" style="padding-top:20px;text-align:right" background layout="prev, pager, next" @current-change="changePage" :page-size="listPagin.limit" :total="listPagin.total">
            </el-pagination>
        </div>

        <pay ref="pay" @pay_downFile_progress="pay_downFile_progress" @look_downFile="look_downFile" />

    </div>
</template>

<script>

import utils from '@/utils/utils'

import pay from "@/components/pay.vue";


import { queryPreRecorDetailList, detail_download, queryDownloadFilePriceByRecordId } from '@/api/home'
import { createOrder } from "@/api/common"
import ssqTable from "./table/ssq.vue"
import dltTable from "./table/dlt.vue"
import fcsdTable from "./table/fcsd.vue"
import plsTable from "./table/pls.vue"

export default {
    components: {
        pay,
        ssqTable, dltTable, fcsdTable, plsTable,
    },
    
    computed:{
      lotteryText(){
          let arr = ['双色球', '大乐透', '福彩3D', '体彩排三']
          return arr[this.lottery.active]
      },
    },
    data () {
        return {
            searchKey: "",

            downFile_progress: 0,

            payShow: false,

            tableLoading: false,

            lottery: {
                arr: ["双色球", "大乐透", "福彩3D", "体彩排三"],
                active: 0,
            },
            type: {
                arr: ["双色球学霸", "积分榜"],
                active: 0,
            },
            headNav: {
                arr: ["最新期", "上一期", "下一期"],
                active: 0,
            },
            typeVIP: {
                arr: ["免费区", "半免费区"],
                active: 0,
            },

            tableData: [],
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },

            currentNumber: '',

            paydb: {},



            tableParamsData: {
                // preType: this.lottery.active,	//彩种
                // number:'',	//期数
                // type: this.headNav.active,	//上一期下一期
                // isFree: this.typeVIP.active == 2 ? '' : this.typeVIP.active,		//0:免费 / 1:VIP学霸区 不传为查询所有

                preType: 0,	//彩种
                number: '',	//期数
                type: 0,	//查询类型 0：最新期 1：上一期 2：下一期
                // isFree: 0,		//0:免费 / 1:VIP学霸区 不传为查询所有
                hasFree: 0,		//0:免费 / 1:VIP学霸区 不传为查询所有

            },


            // 开奖号码
            winning_number: '',

        };
    },
    created () {
        setTimeout(() => {
            this.fetchCaizhongData();
        }, 100);
    },
    watch: {
        'lottery.active' (index) {
            this.tableParamsData.preType = index

            this.currentNumber = ''
            this.tableParamsData.number = ''
            this.tableParamsData.type = 0
            this.headNav.active = 0

            this.$http.get('/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + this.lottery.active).then(res => {
                this.tableParamsData.number = res.data.next
                this.currentNumber = res.data.next
                this.getList()

                this.getLotteryNumber()
            })
        },
        'typeVIP.active' (index) {
            if (index == 2) {
                this.$router.push('ssdgw')
            } else {
                // this.tableParamsData.isFree = index
                this.tableParamsData.hasFree = index
                this.getList()
            }
        }

    },
    beforeRouteEnter (to, from, next) {
        console.log(to.query.type);
        let type = to.query.type;
        let lotteryType = ['ssq', 'dlt', 'fcsd', 'pls']
        console.log(lotteryType.indexOf(type));
        next(vm => {
            // vm 是组件实例
            let activeIndex = lotteryType.indexOf(type);
            vm.lottery.active = activeIndex == -1 ? 0 : activeIndex;
            vm.$vuex('vuex_menuActiveIndex', 1)
        });
    },
    mounted () {
        // 设置默认彩种
        if(location.href.indexOf('?lotteryType') !== -1){
            let lotteryType = location.href.split('?lotteryType=')[1];
            if(lotteryType <= 3){
                this.lottery.active = lotteryType
            }
        }

        this.$http.get('/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + this.lottery.active).then(res => {
            this.tableParamsData.number = res.data.next
            this.currentNumber = res.data.next
            this.getList()
        })

    },
    methods: {
        fetchCaizhongData () {
            const caizhong = this.$route.query.caizhong; // 获取 caizhong 参数
            if (caizhong === 'sss') this.lotteryToggle(0)
            if (caizhong === 'dlt') this.lotteryToggle(1)
            if (caizhong === '3d') this.lotteryToggle(2)
            if (caizhong === 'pl3') this.lotteryToggle(3)
            this.typeVIP.active = 1
        },
        handleLottery (data, type) {

            if (data && type == 'ssq') {
                let arr = data.split(' ')
                return arr.slice(0, 6).join(' ') + ' + ' + arr.slice(-1).join(' ')
            }

            if (data && type == 'dlt') {
                console.log('data', data);
                let arr = data.split(' ')
                return arr.slice(0, 5).join(' ') + ' + ' + arr.slice(-2).join(' ')
            }
        },
        // 根据期号和彩种获取开奖号码
        getLotteryNumber () {
            // let ys = [0,4,1,3]
            let ys = [0, 1, 2, 3]
            this.$http.get('/stage-api/pre/detail/open/number', {
                params: {
                    preType: ys[this.lottery.active],
                    cycle: this.currentNumber,
                }
            }).then(res => {
                this.winning_number = res.data
            })

        },
        // 切换彩种
        lotteryToggle (index) {
            this.searchKey = ""
            this.currentNumber = ''
            this.lottery.active = index
        },
        // 切换最新期，上一期，下一期
        toggleNumber (index) {
            this.headNav.active = index

            let currentNumber = index == 1 ? --this.tableParamsData.number : ++this.tableParamsData.number

            console.log('indx', currentNumber);
            // 最新期
            if (index == 0) {
                this.currentNumber = ''
                this.tableParamsData.number = ''
                this.tableParamsData.type = 0
                this.$http.get('/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + this.lottery.active).then(res => {
                    this.tableParamsData.number = res.data.next
                    this.currentNumber = res.data.next
                    this.getList()
                })
            }
            // 上一期
            if (index == 1) {
                // console.log(currentNumber , localStorage.getItem('latest_issue'));
                // if (currentNumber == localStorage.getItem('latest_issue')) {
                //     this.currentNumber = ''
                //     this.tableParamsData.number = ''
                //     this.tableParamsData.type = 0
                // } else {
                // 	console.log('this.currentNumber',this.currentNumber);
                //     this.tableParamsData.number = --this.currentNumber
                //     this.tableParamsData.type = 1
                // }

                console.log('this.currentNumber', this.currentNumber);
                this.tableParamsData.number = --this.currentNumber
                this.tableParamsData.type = 1

                this.getList()
            }
            // 下一期
            if (index == 2) {
                // if (currentNumber == localStorage.getItem('latest_issue')) {
                //     this.currentNumber = ''
                //     this.tableParamsData.number = ''
                //     this.tableParamsData.type = 0
                // } else {
                //     this.tableParamsData.number = ++this.currentNumber
                //     this.tableParamsData.type = 2
                // }
                this.tableParamsData.number = ++this.currentNumber
                this.tableParamsData.type = 2
                this.getList()
            }

            this.getLotteryNumber()

        },

        // 查阅下载
        view_download (payDb) {


            console.log('view_download--------------', payDb);

            this.$refs.pay.init(payDb)
        },
        // 支付进度条
        pay_downFile_progress (params) {

            console.log('pay_downFile_progress', params);


            let that = this
            setTimeout(_ => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params,
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        // console.log(`下载进度: ${percentCompleted}%`);

                        console.log('that.$parent', that.$parent);
                        that.downFile_progress = percentCompleted >= 100 ? false : percentCompleted
                    },
                }).then(downRes => {

                    console.log('downRes', downRes);

                    if (downRes.code == 500) {
                        return this.$message.error(res.msg)
                    }

                    let preTypeLabel = this.paydb.lotteryType == 0 ? '双色球' :
                        this.paydb.lotteryType == 1 ? '大乐透' :
                            this.paydb.lotteryType == 2 ? '福彩3D' :
                                this.paydb.lotteryType == 3 ? '体彩排三' : ''
                    let fileName = `${preTypeLabel}-${this.paydb.number}期-${this.paydb.nickName}-${this.paydb.indexName}.zip`
                    this.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            }, 1000)
        },
        look_downFile (db) {
            this.$refs.ssqTable.$refs.lookPre.init(db)
        },

        downloadFile (item) {
            // let aa = {
            //     ...item,
            //     userId: item.shrinkId,
            //     preType: this.lottery.active,
            // }
            console.log('page - downloadFile - item', JSON.parse(JSON.stringify(item)));
            // this.paydb = aa

            let params = {
                preType: this.lottery.active,
                preIndexType: item.preIndexType,
                number: item.number,
                createUser: item.shrinkId,
            }

            // console.log('page - downloadFile - params', JSON.parse(JSON.stringify(params)));

            // 查询下载预测文件所需价格
            this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params).then(res => {

                console.log('查询下载预测文件所需价格 - queryDownloadFilePriceByRecordId', res);

                let { price, orderNo } = res.data;

                // 价格为0并且没有订单号
                if (price == 0) {

                    if (orderNo) {
                        // 价格为0并且有订单号直接下载
                        // this.download_the_shrinking_bill({price, orderNo})
                    } else {
                        // 价格为0并且没有订单号，创建订单后直接下载
                        // this.download_the_shrinking_bill({ price, orderNo })





                    }

                    // this.$message.error('该期预测文件免费下载，请直接下载')
                    return
                } else {
                    // if (orderNo) {
                    //     let payDb = {
                    //         avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
                    //         title: item.title,
                    //         nickName: item.nickName,
                    //         number: item.number,
                    //         price: res.data.price,
                    //         indexName: item.indexName,
                    //         strJson: JSON.parse(item[item.preIndexTypeLabel]),
                    //         shrinkId: item.shrinkId,
                    //         productId: res.data.productId,
                    //         specsId: res.data.specsId,
                    //         lotteryType: this.lottery.active,
                    //     }

                    //     console.log('payDb', JSON.parse(JSON.stringify(payDb)));

                    //     this.$refs.pay.init(payDb)
                    // } else {

                    // }

                }

                return


                if (res.data.orderNo) {

                    this.$confirm('您确定下载该缩水单吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let that = this

                        this.$http.get('/stage-api/pre/detail/zipDownload', {
                            params: {
                                orderNo: res.data.orderNo,
                                coin: res.data.price
                            },
                            headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                            responseType: 'blob',
                            onDownloadProgress: (progressEvent) => {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                // console.log(`下载进度: ${percentCompleted}%`);
                                that.downFile_progress = percentCompleted >= 100 ? false : percentCompleted

                            },
                        }).then(downRes => {

                            if (downRes.code == 500) {
                                return this.$message.error(res.msg)
                            }

                            let preTypeLabel = this.lottery.active == 0 ? '双色球' :
                                this.lottery.active == 1 ? '大乐透' :
                                    this.lottery.active == 2 ? '福彩3D' :
                                        this.lottery.active == 3 ? '体彩排三' : ''
                            let fileName = `${preTypeLabel}-${item.number}期-${item.nickName}-${item.indexName}.zip`

                            utils.downloadFile(downRes, fileName, 'application/zip')

                        })


                    }).catch(() => {
                    });




                } else {

                    // let payParams = {
                    // 	money: res.data.price,
                    //     productAuthor: item.shrinkId,
                    //     payType: 'balancepay',
                    //     productId: res.data.productId,
                    //     productModel: '0',
                    //     quantity: '1',
                    //     title: item.title + new Date().getTime(),
                    //     productSpecsId: res.data.specsId,
                    //     uuid: new Date().getTime(),
                    // }

                    // shrinkId

                    let payDb = {
                        avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
                        title: item.title,
                        nickName: item.nickName,
                        number: item.number,
                        price: res.data.price,
                        indexName: item.indexName,
                        strJson: JSON.parse(item[item.preIndexTypeLabel]),
                        shrinkId: item.shrinkId,
                        productId: res.data.productId,
                        specsId: res.data.specsId,
                        lotteryType: this.lottery.active,
                    }

                    console.log('payDb', JSON.parse(JSON.stringify(payDb)));

                    this.$refs.pay.init(payDb)



                }


            })

            return

            detail_download(aa).then(res => {
                console.log('detail_download', res);

                // 付费
                if ('application/json' == res.type) {
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        const text = fileReader.result;

                        console.log('text', text);
                        const { msg, code } = JSON.parse(text);
                        // alert(msg);
                        this.$message.success(msg)

                        if (code == 500) {
                            this.$refs.pay.init()
                        }
                        return

                    }
                    fileReader.readAsText(res);
                }

                // 免费
                if ("application/octet-stream" === res.type) {
                    let downloadElement = document.createElement("a");
                    downloadElement.href = window.URL.createObjectURL(res);

                    let fileName = `${this.lottery.arr[this.lottery.active]}-${this.currentNumber}-(${item.indexName}).txt`

                    downloadElement.download = fileName;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                }

                let element = document.querySelector('#downloadFile')
                element.textContent = "下载完成";

                setTimeout(_ => {
                    element.parentNode.removeChild(element);
                }, 1000)

            })

        },

        getList () {
            this.tableData = []
            this.tableLoading = true

            let { page, limit } = this.listPagin,
                params = `?pageNum=${page}&pageSize=${limit}`;

            delete this.tableParamsData['nickName']
            if (this.searchKey) {
                // params += `&nickName=${this.searchKey}`;
                this.tableParamsData['nickName'] = this.searchKey;
            }
            // console.log('this.tableParamsData', JSON.parse(JSON.stringify(this.tableParamsData)));
            console.log(this.tableParamsData)
            queryPreRecorDetailList(params, this.tableParamsData).then(res => {
                // queryPreRecorDetailList({ ...this.tableParamsData, ...this.listPagin, }).then(res => {
                this.tableLoading = false

                if (res.rows.length) {
                    if (!this.currentNumber) {
                        this.currentNumber = res.rows[0].number
                        localStorage.setItem('latest_issue', res.rows[0].number)  //记录原始最新期数
                    }
                    this.tableData = res.rows
                    this.listPagin.total = res.total
                }
            })
        },
        // 分页状态变化
        changePage (e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
        handleDownload (item, preIndexType) {
            console.log("2222", JSON.parse(JSON.stringify(item)));
            // this.$refs.pay.toggleShow()
            detail_download({
                detailId: '',
                userId: item.shrinkId,
                preType: this.lottery.active,
                preIndexType,
                number: item.number
            }).then(res => {
                console.log('res', res);
                if (res.code == 500) {
                    this.$message.error(res.msg)
                    return
                }

            })
        },


        // 下载缩水单
        download_the_shrinking_bill (res) {
            console.log('下载缩水单 - res', res);
            this.$confirm('您确定下载该缩水单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let that = this

                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params: {
                        orderNo: res.data.orderNo,
                        coin: res.data.price
                    },
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        // console.log(`下载进度: ${percentCompleted}%`);
                        that.downFile_progress = percentCompleted >= 100 ? false : percentCompleted

                    },
                }).then(downRes => {

                    if (downRes.code == 500) {
                        return this.$message.error(res.msg)
                    }

                    let preTypeLabel = this.lottery.active == 0 ? '双色球' :
                        this.lottery.active == 1 ? '大乐透' :
                            this.lottery.active == 2 ? '福彩3D' :
                                this.lottery.active == 3 ? '体彩排三' : ''
                    let fileName = `${preTypeLabel}-${item.number}期-${item.nickName}-${item.indexName}.zip`

                    utils.downloadFile(downRes, fileName, 'application/zip')

                })


            }).catch(() => {
            });
        },
    },

};
</script>

<style lang="scss" scoped>
.lottery {
    margin-top: 10px;
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.2);
    span {
        display: inline-block;
        padding: 20px 30px;
        background-color: #dbdbdb;
        cursor: pointer;
        &.active {
            background-color: #93d2f3;
            color: #000;
        }
    }
}
.type {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    > div {
        span {
            display: inline-block;
            padding: 20px 30px;
        }
    }
    .apply_sss {
        padding: 10px 20px;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }
}
.table {
    .head {
        margin: 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tit {
            color: #347caf;
            font-weight: bold;
            font-size: 20px;
        }
        .nav {
            span {
                background-color: #dbdbdb;
                border: 1px solid rgba(0, 0, 0, 0.2);
                padding: 5px 10px;
                margin-right: 10px;
                border-radius: 10px;
                cursor: pointer;
                &.active {
                    background-color: #93d2f3;
                }
            }
        }
        span {
            display: inline-block;
            padding: 0 10px;
        }
    }
    .pagination {
        margin: 30px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.flexrow {
    display: flex;
    justify-content: flex-end;
    padding: 4px 0;
    .searchinput {
        width: 300px;
    }
}
</style>
